import styles from './Description.module.css';
const Description = (props) => {
    return (<div class={styles.description}>
      {props.children}
    </div>);
};
export default Description;
